import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
var propTypes = {
  /**
   * TableRow requires Cell components as children.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * @ignore
   * Object containing colors
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  className: undefined,
  colorConfig: colors
};
var TableRow = /*#__PURE__*/styled.tr.withConfig({
  displayName: "TableRow",
  componentId: "sc-n5o6fn-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom: ", " solid\n    ", ";\n  :last-child {\n    border: none;\n  }\n"])), calculateRem(1), function (_ref) {
  var colorConfig = _ref.colorConfig;
  return colorConfig.coolGray3;
});
TableRow.propTypes = propTypes;
TableRow.defaultProps = defaultProps;
/**
 * @component
 */

export default TableRow;